class LocalizationForm extends window.BAO.CustomElement() {
  constructor () {
    super()
    this.elements = {
      input: this.els.input.element,
      button: this.els.button.element,
      panel: this.els.panel.element,
    }
    this.elements.button.addEventListener('click', this.openSelector.bind(this))
    this.elements.button.addEventListener(
      'focusout',
      this.closeSelector.bind(this),
    )
    this.addEventListener('keyup', this.onContainerKeyUp.bind(this))

    this.querySelectorAll('a').forEach(item =>
      item.addEventListener('click', this.onItemClick.bind(this)),
    )
  }

  hidePanel () {
    this.elements.button.setAttribute('aria-expanded', 'false')
    this.elements.panel.setAttribute('hidden', true)
  }

  onContainerKeyUp (event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return

    this.hidePanel()
    this.elements.button.focus()
  }

  onItemClick (event) {
    event.preventDefault()
    const form = this.closest('form')
    this.elements.input.value = event.currentTarget.dataset.value
    window.localStorage.setItem(
      this.userLocationName,
      event.currentTarget.dataset.value,
    )

    if (form) form.submit()
  }

  openSelector () {
    this.elements.button.focus()
    this.elements.panel.toggleAttribute('hidden')
    this.elements.button.setAttribute(
      'aria-expanded',
      (
        this.elements.button.getAttribute('aria-expanded') === 'false'
      ).toString(),
    )
  }

  closeSelector (event) {
    const shouldClose =
      event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON'
    if (event.relatedTarget === null || shouldClose) {
      this.hidePanel()
    }
  }

  get userLocationName () {
    return 'BAO-localization'
  }
}

customElements.define('localization-form', LocalizationForm)
